package com.nonopn.skywatcher.common.api

import io.ktor.client.HttpClient

private var baseUrl = "https://api.lpsmanager.io"

class ApiSession(
    // val baseUrl: String,
    client: HttpClient
) {
    private val calls = DoNetworkCalls(client)

    suspend fun profile(): APIUserSession = calls.get("$baseUrl/user")
}
